import { useEffect, useState } from "react";
import { BreadcrumbManager as HeadlessBreadcrumbManager } from "@coveo/headless";
import { PageType } from "components/coveo-headless/types/coveo-headless-types";

type BreadcrumbManagerProps = {
	controller: HeadlessBreadcrumbManager;
	page: string;
};

const BreadcrumbManager = ({ controller, page }: BreadcrumbManagerProps) => {
	const [state, setState] = useState(controller.state);

	useEffect(() => controller.subscribe(() => setState(controller.state)), [controller]);
	return (
		<div
			className={`${
				page === PageType.MyDimensional ? "home-browseby-breadcrumbs" : "insights-breadcrumbs"
			} ${!state?.hasBreadcrumbs ? "insights-breadcrumbs-empty" : ""}`}
			tabIndex={-1}
			role="navigation"
			aria-label="Active filters"
		>
			{state?.hasBreadcrumbs ? (
				<>
					<div className="coveo-headless-breadcrumb-items">
						{state.facetBreadcrumbs.map((facet) =>
							facet.values.map((breadcrumb) => (
								<div
									key={breadcrumb.value.value}
									className="coveo-headless-breadcrumb-value"
									role="button"
									aria-label={`Remove inclusion filter on ${breadcrumb.value.value}`}
									tabIndex={0}
									onClick={() => breadcrumb.deselect()}
									onKeyDown={() => breadcrumb.deselect()}
								>
									<span className="coveo-headless-breadcrumb-caption" data-qa="breadcrumb-caption">
										{breadcrumb.value.value}
									</span>
									<span className="coveo-headless-breadcrumb-clear"></span>
								</div>
							))
						)}
					</div>
					<div
						className="coveo-headless-breadcrumb-clear-all"
						title="Clear All Filters"
						role="button"
						aria-label="Clear All Filters"
						tabIndex={0}
						onClick={() => controller.deselectAll()}
						onKeyDown={() => controller.deselectAll()}
					>
						Clear All Filters
					</div>
				</>
			) : null}
		</div>
	);
};

export default BreadcrumbManager;
